import React from 'react';
import { AnimatedSection } from '../components/AnimatedSection';
export function Quote() {
  return <div className="w-full" data-id="element-403">
      {/* HERO SECTION */}
      <section className="bg-navy text-white py-20 md:py-28 relative overflow-hidden" data-id="element-404">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-405"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center" data-id="element-406">
          <AnimatedSection data-id="element-407">
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight mb-6 max-w-3xl mx-auto" data-id="element-408">
              Request a <span className="text-accent" data-id="element-409">Free Quote</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-410">
              Many projects can be evaluated faster when photos and project
              details are submitted.
            </p>
          </AnimatedSection>
        </div>
      </section>

      <section className="py-20 bg-slate-50" data-id="element-411">
        <div className="max-w-4xl mx-auto px-6" data-id="element-412">
          <AnimatedSection data-id="element-413">
            <div className="bg-white p-4 md:p-8 rounded-sm shadow-xl border border-slate-100" data-id="element-414">
              {/* Jotform Embed */}
              <iframe id="JotFormIFrame-261718702954059" title="Free Quote Request" allow="geolocation; microphone; camera" src="https://form.jotform.com/261718702954059" frameBorder="0" style={{
              minWidth: '100%',
              maxWidth: '100%',
              height: '800px',
              border: 'none'
            }} scrolling="yes" data-id="element-415"></iframe>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}